// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"277":"bebc928e","471":"f0b1aec9"}[chunkId] + ".chunk.css";
};